module.exports = __webpack_public_path__ + "static/media/thumbnail.328936bc.jpg";